import { GET_CURRENT_WEATHER } from '../../constants';

const initialState = {
  data: {},
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case GET_CURRENT_WEATHER.LOAD:
      return {
        ...state,
        loading: true,
      };
    case GET_CURRENT_WEATHER.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case GET_CURRENT_WEATHER.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
